import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import DeliveryRegister from './DeliveryRegister';
import DiaryEntryView from './DiaryEntryView';
import EquipmentRegister from './EquipmentRegister';
import PeopleRegister from './PeopleRegister';
import SubContractorRegister from './SubContractorRegister';

const StyledReportDetailsContainer = styled(Grid)({
  height: 'calc(100vh - 120px)',
  justifyContent: 'space-around',
});

const ReportDetails: React.FC = () => {
  return (
    <StyledReportDetailsContainer size={12} container data-testid="report-details" alignContent="flex-start">
      <DiaryEntryView />
      <Grid container size={12} paddingX={2} spacing={2} data-testid="registers" justifyContent="space-between">
        <Grid container size={8} spacing={2}>
          <PeopleRegister />
          <EquipmentRegister />
          <SubContractorRegister />
        </Grid>
        <Grid size={4}>
          <DeliveryRegister />
        </Grid>
      </Grid>
    </StyledReportDetailsContainer>
  );
};

export default ReportDetails;
